/*
  Copyright (C) 2022 - Jeci SARL - https://jeci.fr

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see https://www.gnu.org/licenses/agpl-3.0.html.
 */

const SUPPORT_LOCALES = ["en", "fr"];
const DIM_EN = ["o", "Ko", "Mo", "Go", "To"];
const DIM_FR = ["o", "Ko", "Mo", "Go", "To"];

/**
 * A service class for handling translation-related operations.
 * This includes methods for converting byte sizes to human-readable formats
 * and detecting the current language setting for localization purposes.
 */
class TranslationService {
  convertBytesToSize(str) {
    if (str === null || str === undefined || str === "") {
      return "";
    }
    let value = parseInt(str);
    if (value === 0) {
      return "0";
    }

    const locale = this.currentLang();
    const sizes = locale === "fr" ? DIM_FR : DIM_EN;

    let i = Math.floor(Math.log(value) / Math.log(1024));
    let size = value / Math.pow(1024, i);
    let displaySize = size < 10 && i > 0 ? size.toFixed(1) : Math.round(size);
    return `${displaySize} ${sizes[i]}`;
  }

  currentLang() {
    let locale =
      localStorage?.getItem("user.language") || window?.navigator?.language;
    if (locale.indexOf("-") > 0) {
      locale = locale.substring(0, locale.indexOf("-"));
    }
    if (!SUPPORT_LOCALES.includes(locale)) {
      locale = "en";
    }

    return locale;
  }
}

export default new TranslationService();
